import { render, staticRenderFns } from "./AuthWarning.vue?vue&type=template&id=4d0d38f0&scoped=true"
import script from "./AuthWarning.vue?vue&type=script&lang=js"
export * from "./AuthWarning.vue?vue&type=script&lang=js"
import style0 from "./AuthWarning.vue?vue&type=style&index=0&id=4d0d38f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0d38f0",
  null
  
)

export default component.exports